(function () {

	let footerObserver = null

	const footer = () => {
		if (footerObserver) footerObserver.disconnect()

		const footerEl = document.querySelector('.footer')
		const headerWrapper = document.querySelector('.header-wrapper')
		if (!footerEl || !headerWrapper) return

		/* Use multiple thresholds — trigger as soon as footer covers most of the viewport.
		   On small laptops, 95% of a 100vh footer may never be visible at once.
		   We trigger at 60% which reliably fires on all screen sizes. */
		footerObserver = new IntersectionObserver(
			(entries) => {
				const entry = entries[0]
				if (entry.isIntersecting && entry.intersectionRatio >= 0.55) {
					headerWrapper.classList.add('header--over-footer')
				} else {
					headerWrapper.classList.remove('header--over-footer')
				}
			},
			{ threshold: [0, 0.25, 0.5, 0.55, 0.6, 0.75, 0.95, 1] }
		)

		footerObserver.observe(footerEl)
	}

	document.addEventListener('shopify:section:load', footer)
	footer()

})();